import { Iab } from '../__generated__/graphql'

const getIabForBackend = (value: string | Iab): Iab => {
  return value.replace('-', '_') as Iab
}

export default getIabForBackend
